import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Services from "@/components/Services";
import Process from "@/components/Process";
import VendorCompare from "@/components/VendorCompare";
import Markets from "@/components/Markets";
import WhyUs from "@/components/WhyUs";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";

export default function LandingPage() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="grain relative min-h-screen overflow-x-clip bg-ink text-txt-1">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <About />
                <Services />
                <Process />
                <VendorCompare />
                <Markets />
                <WhyUs />
                <Contact />
            </main>
            <Footer />
            <FloatingButtons />
        </div>
    );
}
